
<script>
	import listBase from '@_system/components/base/list.vue'
	import distributionIndex from "./distribution/index.vue"
	export default {
		extends: listBase,
		name: 'budgetIndex',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<distributionIndex ref="budgetdistributionIndex" currentrow={this.currentrow}  />,
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'budget',
				windowName: '预算表',
				windowType: 'modal',
				currentrow:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			distribution(e){
				this.currentrow = e
				this.$refs.budgetdistributionIndex.modal_show()
			}
		},
		components: {
			distributionIndex
		}
	}
</script>
